import { LitElement, html } from "lit";

import { customElement, property } from "lit/decorators.js";

import { userThemeButtonStyles } from "./user-theme-button.css";

import "../button/wow-button";

@customElement("user-theme-button")
export class UserThemeButton extends LitElement {
  static override styles = [userThemeButtonStyles];

  @property({ type: Boolean })
  interactive = true;

  @property({ type: Boolean })
  circle = false;

  @property({ type: String })
  primaryColor?: string = "var(--sds-color-white-1000, #fff)";

  @property({ type: String })
  secondaryColor?: string = "var(--sds-color-gray-600, #444)";

  @property({ type: String })
  override title = "";

  @property({ type: String })
  override ariaLabel = "";

  @property({ type: String })
  size: "small" | "medium" | "large" = "medium";

  @property({ type: Boolean, reflect: true, attribute: "full-width" })
  fullWidth = false;

  private handleClick = (event: Event) => {
    if (!this.interactive) {
      event.stopPropagation();
      event.preventDefault();
      return;
    }
  };

  protected override render() {
    return html`
      <wow-button
        .backgroundColor=${this.primaryColor}
        .color=${this.secondaryColor}
        .rounded=${true}
        .square=${this.circle}
        .size=${this.size}
        .fullWidth=${this.fullWidth}
        @click=${this.handleClick}
        .title=${this.title || this.ariaLabel}
        .disabled=${!this.interactive}
      >
        <slot></slot>
      </wow-button>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "user-theme-button": UserThemeButton;
  }
}
